<script setup lang="ts">
withDefaults(
  defineProps<{
    emphasize?: boolean;
    disabled?: boolean | string;
    shadow?: boolean;
    borderColor?: string;
    hideBoxShadow?: boolean;
    draggable?: boolean;
  }>(),
  {
    disabled: false,
    draggable: false,
  }
);

const emit = defineEmits<{
  (e: 'click', ev: MouseEvent): void;
  (e: 'dblclick'): void;
  (e: 'hoverIn', ev: MouseEvent): void;
  (e: 'hoverOut'): void;
  (e: 'mouseleave'): void;
  (e: 'dragstart', ev: DragEvent): void;
}>();

function doClick(ev: MouseEvent) {
  emit('click', ev);
}

function mouseEnter(event: MouseEvent) {
  emit('hoverIn', event);
}

function doDblClick() {
  emit('dblclick');
}
</script>

<template>
  <div
    class="text-bubble-wrapper"
    :class="{
      disabled: disabled,
    }"
    @click="doClick"
    @dblclick="doDblClick"
    @mouseleave="$emit('mouseleave')"
    :draggable="draggable"
    @dragstart="$emit('dragstart', $event)"
  >
    <div
      class="text-bubble uk-border-rounded uk-padding-small annotatorArticleData"
      :class="{
        hover: emphasize && !hideBoxShadow,
        shadow: shadow,
      }"
      :style="{
        outline: emphasize && !hideBoxShadow ? `3px solid ${borderColor || '#2D4756'}` : undefined,
        'outline-offset': emphasize && !hideBoxShadow ? '-3px' : undefined,
        'box-shadow': hideBoxShadow && 'none !important',
        'padding-top': hideBoxShadow && '19px !important',
        'min-height': hideBoxShadow && '129px',
        'transition-property': 'box-shadow, padding-top, min-height, transform',
      }"
      @mouseenter="mouseEnter"
      @mouseleave="$emit('hoverOut')"
    >
      <slot name="top"></slot>

      <slot></slot>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.text-bubble {
  word-wrap: break-word;
  overflow-wrap: break-word;
  word-break: break-word;
}

.text-bubble.hover {
  z-index: 1000;
}
</style>
